import axios from 'axios';

export enum Activity {
  productRegistered = 3,
  copyCheckoutLink = 4,
}

export class ChatBotService {
  private userId?: number;

  public register(userId: number) {
    const chatBotId = window.sessionStorage.getItem('chatBotId');

    if (!chatBotId) {
      return false;
    }

    this.userId = userId;

    return this.request({
      path: 'VincularUsuario',
      resultKey: 'VinculoRealizado',
      data: {
        chatbot: chatBotId,
      },
    });
  }

  public activity(id: Activity) {
    window.sessionStorage.removeItem('chatBotId');

    return this.request({
      path: 'RegistrarAtividade',
      resultKey: 'Resultado',
      data: {
        IdAtividade: id,
      },
    });
  }

  private async request(opts: { path: string; resultKey: string; data: { [key: string]: any } }): Promise<boolean> {
    const { path, resultKey, data } = opts;

    if (!this.userId) {
      return false;
    }

    const result = await axios.post(
      path,
      {
        IdCliente: this.userId,
        ...data,
      },
      {
        baseURL: process.env.REACT_APP_CHATBOT_APIURL,
      }
    );

    return result?.data?.[resultKey] === 1;
  }
}

const chatBotService = new ChatBotService();
export default chatBotService;
